import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M17.777 4.162c-.441-.037-1.007-.037-1.81-.037h-1.134a.625.625 0 0 1 0-1.25h1.16c.771 0 1.388 0 1.885.04.512.042.953.13 1.359.337.65.332 1.18.86 1.511 1.511.207.406.295.847.336 1.359.041.498.041 1.114.041 1.884v7.988c0 .77 0 1.387-.04 1.884-.042.512-.13.953-.337 1.359a3.46 3.46 0 0 1-1.511 1.511c-.406.207-.847.295-1.358.336-.498.041-1.115.041-1.885.041h-1.16a.625.625 0 0 1 0-1.25h1.133c.803 0 1.369 0 1.81-.037.433-.035.692-.102.892-.204a2.2 2.2 0 0 0 .965-.965c.102-.2.169-.459.204-.892.037-.441.037-1.007.037-1.81V8.033c0-.803 0-1.369-.037-1.81-.035-.434-.102-.692-.204-.892a2.208 2.208 0 0 0-.965-.965c-.2-.102-.459-.169-.892-.204Z"
    />
    <path
      fill="currentColor"
      d="M9.67 6.836a.625.625 0 0 1 .883 0l4.722 4.722a.625.625 0 0 1 0 .884l-4.722 4.722a.625.625 0 0 1-.884-.884l3.655-3.655H3.5a.625.625 0 1 1 0-1.25h9.824L9.67 7.72a.625.625 0 0 1 0-.884Z"
    />
  </svg>
`;
